import "cluetip"

export default function calendar(id) {
  const calendar = document.querySelector(`#${id}`)
  if (!calendar) return

  const specialDays = JSON.parse(calendar.dataset.days)

  // jquery-ui datepicker
  $(calendar).datepicker({
    beforeShowDay: function(date) {
      const eventAt = date.toISOString().substring(0, 10)
      if (specialDays[eventAt])
        return [false, "event event-hover", specialDays[eventAt]]

      return [false,""]
    },
    onUpdateDatepicker: function() {
      $(".event-hover").each(function() {
        $(this).cluetip({
          splitTitle: "|",
          showTitle: true,
          leftOffset: 0,
          topOffset: 15,
          cursor: "pointer",
          multiple: true
        })
      })
    }
  })
}
